import { createSlice } from '@reduxjs/toolkit'

export const drawerStore = createSlice({
    name: 'drawer-store',
    initialState: {
        // 打开状态
        isShow: false,
        isFirmwareUpload: false
    },
    reducers: {
        setDrawerShowState: (state, action) => {
            state.isShow = action.payload
        },
        setIsFirmwareUpload: (state, action) => {
            state.isFirmwareUpload = action.payload
        }
    }
})

export const {
    setDrawerShowState,
    setIsFirmwareUpload
} = drawerStore.actions
export default drawerStore.reducer